module.exports = __webpack_public_path__ + "static/img/ppsg@2x.bc1d8a40.png";